import types from './mutationTypes';

export default {
  [types.REGISTER_CLIENT_APP](state, app) {
    state.clientApp = app;
  },
  [types.SET_TRANSLATIONS](state, translations) {
    state.translations = translations;
  },
};
